import React, { Component } from "react";
import {
  Card,
  Badge,
  ButtonDropdown,
  CustomInput,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../redux/actions";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import { Separator } from "../../../components/common/CustomBootstrap";

class LabelItemLeft extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
    };
  }

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems
    );
  };

  onClickedItem = (item) => {
    this.props.onClickedItem(
      // callback
      item,
      this.menuButtonClick,
      [null, 1000, this.props.containerClassnames]
    );
  };

  render() {
    const { dropdownSplitOpen } = this.state;

    return (
      <Card className="mb-3 custom-shadow">
        <div className="d-flex flex-row cursor-pointer">
          <div className={"d-flex flex-grow-1 min-width-zero"}>
            {this.props.item.status ? (
              <div
                onClick={() => {
                  this.onClickedItem(this.props.item);
                }}
                className={classnames(
                  "card-body align-self-center d-flex flex-ssm-column justify-content-between min-width-zero",
                  {
                    "flex-lg-row align-items-lg-center":
                      !this.props.setting.update,
                  }
                )}
              >
                <div className="w-100 list-item-heading mb-1 truncate d-block w-sm-100">
                  <span>{this.props.item.name}</span>
                </div>
                <div className="w-20">
                  <Badge color={"primary"} pill>
                    {this.props.item.status}
                  </Badge>
                </div>
              </div>
            ) : (
              <div
                onClick={() => {
                  this.onClickedItem(this.props.item);
                }}
                className="card-body w-100 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center"
              >
                <div className="list-item-heading mb-1 truncate d-block">
                  <span>{this.props.item.name}</span>
                </div>
              </div>
            )}
            {/* Simple Checkbox - for multi-select */}
            <div
              className="custom-control custom-checkbox align-self-center"
              style={{
                padding: "15px 20px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                this.props.onChangeCheckbox(this.props.item.id, e);
              }}
            >
              <CustomInput
                type="checkbox"
                id={`check-company-${this.props.item.id}`}
                label=""
                checked={this.props.selectedItems.includes(this.props.item.id)}
                onChange={() => {}}
              />
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
})(LabelItemLeft);
